import React from 'react'
import { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import { useMobilePerfViewport } from '../hooks/useMobilePerfViewport'
import { deepSpaceBackgroundImageLayers } from './deepSpaceBackground'

/**
 * Capa de fondo dentro de `#root` (no en `html::before`). Evita parpadeos donde el pseudo
 * del documento queda detrás del canvas de `html` o pierde ante el orden de inyección SC.
 * En móvil usamos CSS estático (`mobile-performance.css`) y omitimos capas costosas aquí.
 */
const Layer = styled.div<{ $layers: string; $bg: string }>`
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background-color: ${({ $bg }) => $bg};
  background-repeat: no-repeat;
  background-image: ${({ $layers }) => $layers};
`

export function DeepSpaceViewportBackdrop() {
  const mobilePerf = useMobilePerfViewport()
  const theme = useContext(ThemeContext)!

  if (mobilePerf) return null

  const layers = deepSpaceBackgroundImageLayers(theme.bg2)
  return <Layer $layers={layers} $bg={theme.bg2} aria-hidden />
}
